
import RugbyHeader from '../components/header/rugby-header'


import './rugby-partners.css'

const RugbyPartners = () => {
    return (
        <>
            <RugbyHeader />
            <div className="partners">
                <div className="partners-container">
                    <div className="partners-box"></div>
                </div>
            </div>
        </>

    );
}


export default RugbyPartners;